module.exports = __webpack_public_path__ + "img/activity.b790019.png";